<form [formGroup]="formGroup">
    <lsq-select
        *ngIf="!reviewMode"
        ngDefaultControl
        class="ar-dropdown"
        [(ngModel)]="field.fieldValue"
        [label]="this.addRequiredAsterisk(fieldSchema)"
        [options]="fieldOption.members"
        [name]="fieldSchema.name"
        [group]="formGroup"
        [formControlName]="fieldSchema.name"
        [innerLabel]="true"
        [isNullable]="true"
        [popover]="fieldSchema.tooltip"
        [popoverDisabled]="!fieldSchema.tooltip"
    >
    </lsq-select>
</form>
